<template>
	<div style="width: 100%;height: 100%;" class="chart">

	</div>
</template>

<script>
	import echarts from 'echarts'

	function setOption(args) {
		var option = {
			tooltip: {
				show:true,
				trigger: 'axis',
				axisPointer: { // 坐标轴指示器，坐标轴触发有效
					type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
				},
				//formatter:'{b0}<br />{a0}: {c0}<br />{a1}: {c0}'
				formatter:(params)=>{
					return `<div>${params[0].name}</div><div><span>${params[0].seriesName} : </span><span>${params[0].value}</span></div><div><span>${params[1].seriesName} : </span><span>${params[0].value+params[1].value}</span></div>`
				}
			},
			color:['#E6A878','#7EC1D4'],
			animation:false,
			calculable: true,
			xAxis: [{
				type: 'category',
				data: args.xAxis
			}],
//			yAxis: [{
//				type: 'value',
//				splitArea: {
//					show: true
//				}
//			}],
			yAxis: {
				type: 'value',
				axisLine: {
		            show: true,
		            lineStyle: {
						color: 'rgba(81,177,203,1)' //坐标轴线线的颜色
					}
		        },
		        splitLine: {
		            show: true,
		        },
		        axisLabel: {
	               color:'#57617B'
				},
			},
			series: args.series
		};

		return option;
	}
	export default {
		name: 'CsStackBar',
		props: ['args'],
		methods: {
			initChart() {

				window.addEventListener('resize', function() {
					this.myChart.resize()
				}.bind(this))
			},
			resize: function() {
				this.myChart.resize()
			},
			reDrawChart: function(args) {
				var container = this.$el;
				this.initChart();
				this.myChart = echarts.init(container);
				this.myChart.setOption(setOption(args), false);
			}
		},
		mounted: function(el) {}

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/echarts/stackBarChart.vue